import React from 'react';
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

export interface SidebarItemProps {
    icon: LucideIcon;
    label: string;
    to: string;
    isActive?: boolean;
    context?: string; // e.g. "Department", "Office"
    isCollapsed?: boolean;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({ icon: Icon, label, to, isActive, isCollapsed }) => (
    <Link
        to={to}
        title={isCollapsed ? label : undefined}
        className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 mb-1 no-underline group ${isActive
            ? 'text-accent-electric bg-accent-electric/5 shadow-[inset_0_0_15px_rgb(var(--accent-electric-rgb)/0.03)]'
            : 'text-text-secondary hover:bg-surface-hover hover:text-text-primary'
            } ${isCollapsed ? 'justify-center px-0' : ''}`}
    >
        <div className={`transition-all duration-300 ${isActive ? 'text-accent-electric drop-shadow-[0_0_8px_rgb(var(--accent-electric-rgb)/0.5)]' : 'group-hover:text-text-primary'}`}>
            <Icon size={20} />
        </div>
        {!isCollapsed && <span className="font-semibold tracking-wide text-sm">{label}</span>}
        {isActive && !isCollapsed && (
            <div className="ml-auto w-1.5 h-1.5 rounded-full bg-accent-electric shadow-[0_0_12px_var(--accent-electric),0_0_20px_rgb(var(--accent-electric-rgb)/0.4)]" />
        )}
    </Link>
);
